<template>
  <aside
    class="sidenav bg-white navbar navbar-vertical navbar-expand-xs border-0 border-radius-xl my-3 fixed-start ms-4"
    id="sidenav-main"
  >
    <div class="sidenav-header">
      <i
        class="fas fa-times p-3 cursor-pointer text-secondary opacity-5 position-absolute end-0 top-0 d-none d-xl-none"
        aria-hidden="true"
        id="iconSidenav"
      ></i>
      <a class="navbar-brand m-0" href="" target="#">
        <img
          src="/assets/img/logos/logo-enjoy.png"
          class="navbar-brand-img h-100"
          alt="main_logo"
        />
        <!-- <span class="ms-1 font-weight-bold">Enjoy</span> -->
      </a>
    </div>
    <hr class="horizontal dark mt-0" />
    <div class="collapse navbar-collapse w-auto" id="sidenav-collapse-main">
      <ul class="navbar-nav">
        <li class="nav-item">
          <Link
            :href="route('admin.profile')"
            class="nav-link"
            :class="route().current('admin.profile') ? 'active' : ' '"
          >
            <div
              class="icon icon-shape icon-sm border-radius-md text-center me-2 d-flex align-items-center justify-content-center"
            >
              <i class="ni ni-single-02 text-primary text-sm opacity-10"></i>
            </div>
            <span class="nav-link-text ms-1">Perfil</span>
          </Link>
        </li>

        <li class="nav-item">
          <Link
            :href="route('admin.notificacao')"
            class="nav-link"
            :class="route().current('admin.notificacao') ? 'active' : ' '"
          >
            <div
              class="icon icon-shape icon-sm border-radius-md text-center me-2 d-flex align-items-center justify-content-center"
            >
              <i class="ni ni-bell-55 text-primary text-sm opacity-10"></i>
            </div>
            <span class="nav-link-text ms-1">Notificação &nbsp;</span>

            <span v-if="this.badge_notificar != 0" class="badge badge-danger">{{
              this.badge_notificar
            }}</span>
          </Link>
        </li>

        <li class="nav-item">
          <Link
            :href="route('admin.dashboard')"
            class="nav-link"
            :class="route().current('admin.dashboard') ? 'active' : ' '"
          >
            <div
              class="icon icon-shape icon-sm border-radius-md text-center me-2 d-flex align-items-center justify-content-center"
            >
              <i class="ni ni-tv-2 text-primary text-sm opacity-10"></i>
            </div>
            <span class="nav-link-text ms-1">Dashboard</span>
          </Link>
        </li>

        <li class="nav-item" v-if="$page.props.auth.hasRole.superAdmin">
          <Link
            :href="route('admin.prefeituras.index')"
            class="nav-link"
            :class="route().current('admin.prefeituras.*') ? 'active' : ' '"
          >
            <div
              class="icon icon-shape icon-sm border-radius-md text-center me-2 d-flex align-items-center justify-content-center"
            >
              <i
                class="ni ni-calendar-grid-58 text-warning text-sm opacity-10"
              ></i>
            </div>
            <span class="nav-link-text ms-1">Prefeituras</span>
          </Link>
        </li>

        <li class="nav-item" v-if="$page.props.auth.hasRole.superAdmin">
          <a
            data-bs-toggle="collapse"
            href="#roles"
            class="nav-link collapsed"
            aria-controls="roles"
            role="button"
            aria-expanded="false"
          >
            <div
              class="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center"
            >
              <i class="ni ni-ungroup text-warning text-sm opacity-10"></i>
            </div>
            <span class="nav-link-text ms-1">Acessos</span>
          </a>
          <div class="collapse" id="roles" style="">
            <ul class="nav ms-4">
              <li class="nav-item">
                <Link
                  class="nav-link"
                  :href="route('admin.roles.index')"
                  :class="route().current('admin.roles.*') ? 'active' : ' '"
                >
                  <span class="sidenav-mini-icon"> P </span>
                  <span class="sidenav-normal"> Perfis </span>
                </Link>
              </li>

              <li class="nav-item">
                <Link
                  class="nav-link"
                  :href="route('admin.permissions.index')"
                  :class="
                    route().current('admin.permissions.*') ? 'active' : ' '
                  "
                >
                  <span class="sidenav-mini-icon"> P </span>
                  <span class="sidenav-normal"> Permissões </span>
                </Link>
              </li>

        <!--       <li class="nav-item">
                <Link
                  class="nav-link"
                  :href="route('admin.settings')"
                  :class="route().current('admin.settings') ? 'active' : ' '"
                >
                  <span class="sidenav-mini-icon"> S </span>
                  <span class="sidenav-normal"> Configurações </span>
                </Link>
              </li> -->
            </ul>
          </div>
        </li>

        <li
          class="nav-item"
          v-if="
            $page.props.auth.hasRole.superAdmin ||
            $page.props.auth.hasRole.admin ||
            $page.props.auth.hasRole.moderador
          "
        >
          <Link
            :href="route('admin.usuarios.index')"
            class="nav-link"
            :class="route().current('admin.usuarios.*') ? 'active' : ' '"
          >
            <div
              class="icon icon-shape icon-sm border-radius-md text-center me-2 d-flex align-items-center justify-content-center"
            >
              <i class="fas fa-users text-primary text-sm"></i>
            </div>
            <span class="nav-link-text ms-1">Usuários</span>
          </Link>
        </li>

        <li
          class="nav-item"
          v-if="
            $page.props.auth.hasRole.superAdmin ||
            $page.props.auth.hasRole.admin ||
            $page.props.auth.hasRole.moderador ||
            $page.props.auth.hasRole.editorNoticia
          "
        >
          <a
            data-bs-toggle="collapse"
            href="#noticias"
            class="nav-link collapsed"
            aria-controls="noticias"
            role="button"
            aria-expanded="false"
          >
            <div
              class="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center"
            >
              <i class="fas fa-newspaper text-primary text-sm"></i>
            </div>
            <span class="nav-link-text ms-1">Notícias</span>
          </a>
          <div class="collapse" id="noticias" style="">
            <ul class="nav ms-4">
              <li class="nav-item">
                <Link
                  :href="route('admin.noticias-categoria.index')"
                  class="nav-link"
                  :class="
                    route().current('admin.noticias-categoria.*')
                      ? 'active'
                      : ' '
                  "
                >
                  <span class="sidenav-mini-icon"> C </span>
                  <span class="sidenav-normal"> Categorias de Noticías </span>
                </Link>
              </li>

              <li class="nav-item">
                <Link
                  :class="route().current('admin.noticias.*') ? 'active' : ' '"
                  class="nav-link"
                  :href="route('admin.noticias.index')"
                >
                  <span class="sidenav-mini-icon"> N </span>
                  <span class="sidenav-normal"> Notícias </span>
                </Link>
              </li>
            </ul>
          </div>
        </li>

        <li
          class="nav-item"
          v-if="
            $page.props.auth.hasRole.superAdmin ||
            $page.props.auth.hasRole.admin ||
            $page.props.auth.hasRole.moderador ||
            $page.props.auth.hasRole.editorServico
          "
        >
          <a
            data-bs-toggle="collapse"
            href="#servicos"
            class="nav-link collapsed"
            aria-controls="servicos"
            role="button"
            aria-expanded="false"
          >
            <div
              class="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center"
            >
              <i class="fas fa-list-alt text-primary text-sm"></i>
            </div>
            <span class="nav-link-text ms-1">Serviços</span>
          </a>
          <div class="collapse" id="servicos" style="">
            <ul class="nav ms-4">
              <li class="nav-item">
                <Link
                  :href="route('admin.servicos-categoria.index')"
                  class="nav-link"
                  :class="
                    route().current('admin.servicos-categoria.*')
                      ? 'active'
                      : ' '
                  "
                >
                  <span class="sidenav-mini-icon"> C </span>
                  <span class="sidenav-normal"> Categorias de Serviços </span>
                </Link>
              </li>

              <li class="nav-item">
                <Link
                  :href="route('admin.subcategorias.index')"
                  class="nav-link"
                  :class="
                    route().current('admin.subcategorias.*') ? 'active' : ' '
                  "
                >
                  <span class="sidenav-mini-icon"> S </span>
                  <span class="sidenav-normal"> Subcategorias </span>
                </Link>
              </li>

              <li class="nav-item">
                <Link
                  v-if="$page.props.auth.hasRole.superAdmin"
                  :class="route().current('admin.tags.*') ? 'active' : ' '"
                  class="nav-link"
                  :href="route('admin.tags.index')"
                >
                  <span class="sidenav-mini-icon"> T </span>
                  <span class="sidenav-normal"> Tags </span>
                </Link>
              </li>

              <li class="nav-item">
                <Link
                  :class="
                    route().current('admin.servicos.index') ? 'active' : ' '
                  "
                  class="nav-link"
                  :href="route('admin.servicos.index')"
                >
                  <span class="sidenav-mini-icon"> S </span>
                  <span class="sidenav-normal"> Serviços </span>
                </Link>
              </li>

              <li class="nav-item">
                <Link
                  :class="
                    route().current('admin.servicos.aprovar.index')
                      ? 'active'
                      : ' '
                  "
                  class="nav-link"
                  :href="route('admin.servicos.aprovar.index')"
                >
                  <span class="sidenav-mini-icon"> A </span>
                  <span class="sidenav-normal"> Aprovação de Serviços </span>
                </Link>
              </li>
            </ul>
          </div>
        </li>

        <li
          class="nav-item"
          v-if="
            $page.props.auth.hasRole.lojistaAdmin ||
            $page.props.auth.hasRole.superAdmin
          "
        >
          <a
            data-bs-toggle="collapse"
            href="#lojistas"
            class="nav-link collapsed"
            aria-controls="lojistas"
            role="button"
            aria-expanded="false"
          >
            <div
              class="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center"
            >
              <i class="ni ni-ungroup text-warning text-sm opacity-10"></i>
            </div>
            <span class="nav-link-text ms-1">Gestão</span>
          </a>
          <div class="collapse" id="lojistas" style="">
            <ul class="nav ms-4">
              <li class="nav-item">
                <Link
                  :href="route('admin.lojistas.servico')"
                  class="nav-link"
                  :class="
                    route().current('admin.lojistas.servico') ? 'active' : ' '
                  "
                >
                  <span class="sidenav-mini-icon"> S </span>
                  <span  class="sidenav-normal"> Serviço </span>
                </Link>
              </li>

              <li class="nav-item">
                <Link
                v-if="$page.props.user.servico_id"
                  :href="route('admin.cupons.index')"
                  class="nav-link"
                  :class="route().current('admin.cupons.*') ? 'active' : ' '"
                >
                  <span class="sidenav-mini-icon"> S </span>
                  <span class="sidenav-normal"> Cupons </span>
                </Link>
              </li>

              <li class="nav-item">
                <Link
                v-if="$page.props.user.servico_id"
                  :href="route('admin.lojistas.usuarios.index')"
                  class="nav-link"
                  :class="
                    route().current('admin.lojistas.usuarios.index')
                      ? 'active'
                      : ' '
                  "
                >
                  <span class="sidenav-mini-icon"> U </span>
                  <span class="sidenav-normal"> Usuários </span>
                </Link>
              </li>
            </ul>
          </div>
        </li>

        <li class="nav-item">
          <Link
            :href="route('logout')"
            as="link"
            method="post"
            class="nav-link"
            style="cursor: pointer"
          >
            <div
              class="icon icon-shape icon-sm border-radius-md text-center me-2 d-flex align-items-center justify-content-center"
            >
              <i class="ni ni-tv-2 text-danger text-sm opacity-10"></i>
            </div>
            <span class="nav-link-text ms-1">Logout</span>
          </Link>
        </li>
        <!--  <li class="nav-item">
            <a class="nav-link" href="../pages/billing.html">
              <div
                class="
                  icon icon-shape icon-sm
                  border-radius-md
                  text-center
                  me-2
                  d-flex
                  align-items-center
                  justify-content-center
                "
              >
                <i class="ni ni-credit-card text-success text-sm opacity-10"></i>
              </div>
              <span class="nav-link-text ms-1">Billing</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="../pages/virtual-reality.html">
              <div
                class="
                  icon icon-shape icon-sm
                  border-radius-md
                  text-center
                  me-2
                  d-flex
                  align-items-center
                  justify-content-center
                "
              >
                <i class="ni ni-app text-info text-sm opacity-10"></i>
              </div>
              <span class="nav-link-text ms-1">Virtual Reality</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="../pages/rtl.html">
              <div
                class="
                  icon icon-shape icon-sm
                  border-radius-md
                  text-center
                  me-2
                  d-flex
                  align-items-center
                  justify-content-center
                "
              >
                <i class="ni ni-world-2 text-danger text-sm opacity-10"></i>
              </div>
              <span class="nav-link-text ms-1">RTL</span>
            </a>
          </li>
          <li class="nav-item mt-3">
            <h6
              class="
                ps-4
                ms-2
                text-uppercase text-xs
                font-weight-bolder
                opacity-6
              "
            >
              Account pages
            </h6>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="../pages/profile.html">
              <div
                class="
                  icon icon-shape icon-sm
                  border-radius-md
                  text-center
                  me-2
                  d-flex
                  align-items-center
                  justify-content-center
                "
              >
                <i class="ni ni-single-02 text-dark text-sm opacity-10"></i>
              </div>
              <span class="nav-link-text ms-1">Profile</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="../pages/sign-in.html">
              <div
                class="
                  icon icon-shape icon-sm
                  border-radius-md
                  text-center
                  me-2
                  d-flex
                  align-items-center
                  justify-content-center
                "
              >
                <i
                  class="ni ni-single-copy-04 text-warning text-sm opacity-10"
                ></i>
              </div>
              <span class="nav-link-text ms-1">Sign In</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="../pages/sign-up.html">
              <div
                class="
                  icon icon-shape icon-sm
                  border-radius-md
                  text-center
                  me-2
                  d-flex
                  align-items-center
                  justify-content-center
                "
              >
                <i class="ni ni-collection text-info text-sm opacity-10"></i>
              </div>
              <span class="nav-link-text ms-1">Sign Up</span>
            </a>
          </li> -->
      </ul>
    </div>
    <div class="sidenav-footer mx-3">
      <!--       <div class="card card-plain shadow-none" id="sidenavCard">
          <img class="w-50 mx-auto" src="/assets/img/illustrations/icon-documentation.svg" alt="sidebar_illustration">
          <div class="card-body text-center p-3 w-100 pt-0">
            <div class="docs-info">
              <h6 class="mb-0">Need help?</h6>
              <p class="text-xs font-weight-bold mb-0">Please check our docs</p>
            </div>
          </div>
        </div>
        <a href="https://www.creative-tim.com/learning-lab/bootstrap/license/argon-dashboard" target="_blank" class="btn btn-dark btn-sm w-100 mb-3">Documentation</a>
        <a class="btn btn-primary btn-sm mb-0 w-100" href="https://www.creative-tim.com/product/argon-dashboard-pro?ref=sidebarfree" type="button">Upgrade to pro</a> -->
    </div>
  </aside>
</template>
  <script>
import { Link } from "@inertiajs/inertia-vue3";
import axios from "axios";

export default {
  components: {
    Link,
  },

    data() {
      return {
        badge_notificar: 0,
      };
    },

    methods: {
      notificar: function () {
        axios.get('/api/notificacaos/badge').then(response => {
          this.badge_notificar = response.data;
          // console.log(this.badge_notificar);

          setTimeout(this.notificar, 120000);
        });
      }

    },

    mounted() {
      this.notificar();
  }

  };
  </script>
